/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

var metadata = {
  name: "core/navigation-menu-item",
  category: "layout",
  attributes: {
    label: {
      type: "string"
    },
    destination: {
      type: "string"
    },
    nofollow: {
      type: "boolean",
      "default": false
    },
    title: {
      type: "string"
    },
    description: {
      type: "string"
    },
    opensInNewTab: {
      type: "boolean",
      "default": false
    }
  }
};
import edit from './edit';
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Menu Item (Experimental)'),
  parent: ['core/navigation-menu'],
  icon: 'admin-links',
  description: __('Add a page, link, or other item to your Navigation Menu.'),
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map